"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var settings_1 = require("./settings");
var print_settings_1 = require("./print-settings");
var toolbar_1 = require("./toolbar");
var overview_1 = require("./overview");
var content_1 = require("./content");
var image_viewer_1 = require("./image-viewer");
var html_definitions_1 = require("./html-definitions");
// Implements the core functionality.
var Rslidy = /** @class */ (function () {
    function Rslidy() {
        // Members
        this.utils = new utils_1.Utils();
        this.running = false;
        this.num_slides = 0;
        this.shift_pressed = false;
        /*ctrl_pressed: boolean = false;
        alt_pressed: boolean = false;
        meta_pressed: boolean = false;*/
        this.low_light_mode = false;
        this.shortcuts_disabled = false;
        this.timer_enabled = false;
        this.timer_time = 0;
        this.timer_thread = null;
        //Custom settings
        this.image_viewer = true;
        // Presentation time in seconds. 0 to disable (hides timer).
        this.presentation_time = 0;
        this.close_menu_on_selection = false;
        this.close_menu_on_blur = true;
        this.close_navigation_on_selection = false;
        this.show_slide_dividers = true;
        this.start_in_low_light_mode = false;
        this.start_with_toolbar_minimized = false;
        this.block_slide_text_selection = false;
        // Advanced custom settings
        /* Use of custom aspect ratio for slides. Possible values are e.g. 4/3 or
        16/9. 0 disables it and makes it calculate dynamically. */
        this.custom_aspect_ratio = 4 / 3;
        // Used when custom_aspect_ratio is set to a value greater than zero.
        this.custom_width = 1000;
        this.overview_slide_zoom = 1.2;
        this.doubletap_delay = 200; // Double tap delay in ms
        this.min_slide_font = 0.1; // in em
        this.max_slide_font = 5.0; // in em
        this.font_step = 0.1; // in em
        this.swipe_max_duration = 400; // maximum duration of swipe in ms
        this.swipe_threshold = 3.75; // swipe distance in rem
        /* how many times the x distance should be greater than the y distance (1.0
        means x has to be > y, 2.0 means x has to be > 2 * y, 0.0 means disabled) */
        this.swipe_y_limiter = 1.0;
        this.print_frame = "0.05rem solid black";
        this.image_viewer_background = "rgba(0, 0, 0, 0.9)";
        // Members storing relevant data for touch gestures
        this.tap_last = 0;
        this.start_x = 0;
        this.start_y = 0;
        this.delta_x = 0;
        this.delta_y = 0;
        // Members storing relevant data for TILT/SHAKE gestures
        // Shake sensitivity, smaller number = more shake required
        this.shake_sensitivity = 0.8;
        this.shakes = 0; // Current number of shakes
        this.required_shakes = 4; // Number of consecutive shakes required
        this.last_shake = 0; // Time of last shake (in ms)
        // Timeframe for reaching required_shakes, resets with each shake
        this.shake_time_limit = 500;
        // Only accept shakes after a certain interval
        // Prevents false positives for devices with high refresh rates
        this.min_shake_interval = 50;
        // An action will be performed after returning to tilt_center from an angle
        // between tilt_lower and tilt_upper
        this.tilt = 0; // Current tilt angle
        this.tilt_center = 10;
        this.tilt_lower = 15; // Range ~ 15-40
        this.tilt_upper = 35;
        this.tilt_allowed = false; // If true, perform a tilt action when possible
        this.tilt_action = null; // Gets set to either navPrevious or navNext
        // Constants
        this.MENU = 0;
        this.PRINT_MENU = 1;
    }
    // ---
    // Description: Handles the initialization of rslidy, e.g. setting up the
    // menus.
    // ---
    Rslidy.prototype.init = function () {
        var _this = this;
        // check for section over div slide and add classes for compatibility
        var sections = document.getElementsByTagName("section");
        for (var i = 0; i < sections.length; i++)
            if (sections[i].parentElement.nodeName == "BODY")
                sections[i].classList.add("slide");
        // generate html from slides for overview thumbnails, and add aria tags
        var slides = document.querySelectorAll(".slide");
        this.num_slides = slides.length;
        if (this.num_slides == 0)
            return;
        var slides_html = new Array(this.num_slides);
        for (var i = 0; i < this.num_slides; i++) {
            slides_html[i] = slides[i].outerHTML.replace(/id=\"*\"/g, "");
            slides_html[i] = slides_html[i].replace(/href=\"*\"/g, "class=\"rslidy-link\"");
            slides[i].setAttribute("role", "region");
            slides[i].setAttribute("aria-label", "Slide " + (i + 1));
        }
        // create a wrapper for the new body
        var wrapper = document.createElement("div");
        wrapper.id = "rslidy-column-flex";
        // add content section to the wrapper
        this.utils.appendHtmlString(wrapper, html_definitions_1.content_section);
        var cs = wrapper.querySelector('#rslidy-content-section');
        // move the old body's children into the content section
        while (document.body.firstChild)
            cs.appendChild(document.body.firstChild);
        // Append the wrapper to the body
        document.body.appendChild(wrapper);
        this.imageViewer = new image_viewer_1.ImageViewerComponent();
        this.utils.prependHtmlString(document.body, html_definitions_1.notes_text);
        this.utils.prependHtmlString(document.body, html_definitions_1.help_text);
        this.toolbar = new toolbar_1.ToolbarComponent();
        this.settings = new settings_1.SettingsComponent();
        this.printSettings = new print_settings_1.PrintSettingsComponent();
        this.overview = new overview_1.OverviewComponent(slides_html);
        this.content = new content_1.ContentComponent(cs);
        // If hash is on help, show the first slide and the help panel
        if (window.location.hash.match("#rslidy-help")) {
            this.content.showSlide(0, false);
            this.toolbar.helpToggleClicked();
        }
        // Show first slide with bad or no hash
        else if (!window.location.hash.match(/#[0-9]+/))
            this.content.showSlide(0, false);
        this.addListeners();
        this.initTimer();
        this.onHashchange();
        this.settings.loadSettings();
        this.settings.doCustomSettingAdaptions();
        this.printSettings.loadSettings();
        this.setTabindexAndCallbacks();
        window.onbeforeunload = function () {
            _this.settings.saveSettings();
            _this.printSettings.saveSettings();
        };
        // Disable keyboard shortcuts on right click menu open
        window.oncontextmenu = function (e) {
            _this.shortcuts_disabled = true;
            setTimeout(function () { return _this.shortcuts_disabled = false; }, 3000);
        };
        this.running = true;
    };
    // ---
    // Description: Sets tabindex, aria tags and callbacks for checkboxes
    // ---
    Rslidy.prototype.setTabindexAndCallbacks = function () {
        var _this = this;
        var labels = document.querySelectorAll("label[id*=\"checkbox\"]");
        var _loop_1 = function (i) {
            var l = labels[i];
            l.setAttribute("tabindex", "0");
            input = l.querySelector("input");
            l.setAttribute("role", "checkbox");
            l.setAttribute("aria-checked", String(input.checked));
            input.addEventListener("change", function () {
                l.setAttribute("aria-checked", String(this.checked));
            });
            l.addEventListener("keyup", function (e) { return _this.checkboxCallback(e, l); });
        };
        var input;
        for (var i = 0; i < labels.length; i++) {
            _loop_1(i);
        }
    };
    // ---
    // Description: Handles keyup for checkboxes
    // e: event
    // l: the label of the checkbox
    // ---
    Rslidy.prototype.checkboxCallback = function (e, l) {
        if (l != document.activeElement)
            return;
        var key = e.keyCode ? e.keyCode : e.which;
        if (key == 13 || key == 32) { //return and space
            var i = l.querySelector("input");
            if (!i.disabled) {
                i.checked = !i.checked;
                l.setAttribute("aria-checked", String(i.checked));
                i.dispatchEvent(new Event("click"));
            }
        }
    };
    // ---
    // Description: Adds event listeners like left/right keys.
    // ---
    Rslidy.prototype.addListeners = function () {
        var _this = this;
        // Key listeners
        window.onkeyup = function (e) { return _this.keyPressed(e); };
        // Window listeners
        window.addEventListener("hashchange", function () {
            this.onHashchange();
        }.bind(this));
        // Allow simple touch events on speaker notes overlay (double tap -> hide)
        var speaker_notes_overlay = document.getElementById("rslidy-speakernotes-overlay");
        speaker_notes_overlay.addEventListener("touchstart", function (e) {
            return _this.content.onTouchstart(e);
        }, { passive: true });
        // Window listeners
        window.onresize = function (e) {
            this.overview.adjustOverviewPanel();
        }.bind(this);
        // Device listeners used for TILT and SHAKE
        // add only if possible without permissions
        if (window.DeviceMotionEvent &&
            !(typeof window.DeviceMotionEvent.requestPermission === 'function')) {
            window.addEventListener("devicemotion", function (e) {
                this.onDeviceMotion(e);
            }.bind(this));
        }
        if (window.DeviceOrientationEvent &&
            !(typeof window.DeviceOrientationEvent.requestPermission === 'function')) {
            window.addEventListener("deviceorientation", function (e) {
                this.onDeviceOrientation(e);
            }.bind(this));
        }
    };
    // ---
    // Description: Initializes the timer.
    // ---
    Rslidy.prototype.initTimer = function () {
        // Initialize the timer or hide it if this.presentation_time <= 0
        var timer = document.getElementById("rslidy-timer");
        // Hide timer or set time
        if (this.presentation_time <= 0)
            timer.classList.add("rslidy-hidden");
        else {
            var minutes = Math.floor(this.presentation_time / 60);
            var seconds = this.presentation_time % 60;
            timer.innerHTML =
                this.utils.toTwoDigits(minutes) + ":" + this.utils.toTwoDigits(seconds);
            this.timer_time = this.presentation_time;
        }
    };
    // ---
    // Description: Toggles the timer. Works only if this.presentation_time > 0.
    // ---
    Rslidy.prototype.toggleTimer = function () {
        // Return if this.presentation_time <= 0
        if (this.presentation_time <= 0)
            return;
        // Reset and return if this.timer_time <= 0
        if (this.timer_time <= 0) {
            this.initTimer();
            return;
        }
        if (this.timer_enabled == false) {
            // Run
            this.timer_thread = setInterval(function () {
                // Break out if this.presentation_time is <= 0
                if (this.timer_time <= 0) {
                    clearInterval(this.timer_thread);
                    this.timer_enabled = false;
                    return;
                }
                this.timer_time -= 1;
                var timer = document.getElementById("rslidy-timer");
                var minutes = Math.floor(this.timer_time / 60);
                var seconds = this.timer_time % 60;
                timer.innerHTML =
                    this.utils.toTwoDigits(minutes) +
                        ":" +
                        this.utils.toTwoDigits(seconds);
            }.bind(this), 1000);
            this.timer_enabled = true;
        }
        else {
            // Stop
            clearInterval(this.timer_thread);
            this.timer_enabled = false;
        }
    };
    // ---
    // Description: Called whenever a key is pressed.
    // e: Event.
    // ---
    Rslidy.prototype.keyPressed = function (e) {
        var key = e.keyCode ? e.keyCode : e.which;
        // Check if input or textarea has focus, if so, cancel
        var n = document.activeElement.nodeName;
        if (n === "INPUT" || n === "TEXTAREA")
            return;
        // If flag is set, disable it and ignore current input
        if (this.shortcuts_disabled) {
            this.shortcuts_disabled = false;
            return;
        }
        // Ignore keys when viewing all slides, except toggle back and fonts
        if (this.toolbar.allslides && !(key == 65 || key == 82 || key > 100))
            return;
        // Ignore unused modifiers (to allow ctrl+c etc.)
        if (e.ctrlKey || e.altKey || e.metaKey)
            return;
        // Modifier keys (SHIFT, CTRL, ALT, META (WIN on Windows, CMD on Mac))
        this.shift_pressed = e.shiftKey;
        /*this.ctrl_pressed = e.ctrlKey;
        this.alt_pressed = e.altKey;
        this.meta_pressed = e.metaKey;*/
        //console.log("Key event: " + key + " " + String.fromCharCode(key));
        // Normal key codes
        switch (key) {
            case 32: //space
                if (document.getElementById("rslidy-checkbox-space").checked)
                    this.content.navNext(true);
                break;
            case 34: //page down
            case 39: //right
                this.content.navNext(true);
                break;
            case 33: //page up
            case 37: //left
                this.content.navPrevious(true);
                break;
            case 35: //end
                this.content.navLast();
                break;
            case 36: //home
                this.content.navFirst();
                break;
            case 78: //N
                this.toggleSpeakerNotes(null, false);
                break;
            case 65: //A
                this.toolbar.displayToggleClicked();
                break;
            case 67: //C
                this.toolbar.tocToggleClicked();
                break;
            case 79: //O
                this.toolbar.overviewToggleClicked();
                break;
            case 72: //H
                this.toolbar.helpToggleClicked();
                break;
            case 83: //S
                this.toolbar.menuToggleClicked(this.MENU);
                break;
            case 80: //P
                this.toolbar.menuToggleClicked(this.PRINT_MENU);
                break;
            case 84: //T
                this.toolbar.showHideToggleClicked();
                break;
            case 74: //J
                this.focusJumpText();
                break;
            case 107: //+
            case 171: //+
            case 187: //+ (chrome)
                if (this.imageViewer.active)
                    this.imageViewer.zoomIn();
                else if (this.shift_pressed)
                    this.settings.changeUIFont(null, 1);
                else
                    this.settings.changeSlideFont(null, 1);
                break;
            case 109: //-
            case 173: //-
            case 189: //- (chrome)
                if (this.imageViewer.active)
                    this.imageViewer.zoomOut();
                else if (this.shift_pressed)
                    this.settings.changeUIFont(null, -1);
                else
                    this.settings.changeSlideFont(null, -1);
                break;
            case 82: //R
                if (this.imageViewer.active)
                    this.imageViewer.initialZoom();
                else if (this.shift_pressed)
                    this.settings.changeUIFont(null, 0);
                else
                    this.settings.changeSlideFont(null, 0);
                break;
            case 27: //escape
                this.imageViewer.close();
                this.toolbar.closeMenues();
                break;
            default:
                if (key >= 48 && key <= 57) //48-57 -> 0-9
                    this.focusJumpText(key - 48);
        }
    };
    // ---
    // Description: Focus the rslidy-slide-input for Jump to Slide
    // n (optional): Adds the number to the input field
    // ---
    Rslidy.prototype.focusJumpText = function (n) {
        var j = document.getElementById("rslidy-slide-input");
        if (n == undefined)
            j.value = "";
        else
            j.value = "" + n;
        j.focus();
    };
    // ---
    // Description: Called whenever a key in the slide input text box was pressed.
    // e: The event.
    // ---
    Rslidy.prototype.slideInputKeyPressed = function (e) {
        var key = e.keyCode ? e.keyCode : e.which;
        var slide_input = document.getElementById("rslidy-slide-input");
        var value = slide_input.value;
        if (key == 13 /*enter*/) {
            var is_number = /^[0-9]+$/.test(value);
            if (is_number == true)
                this.content.showSlide(this.utils.toInt(value) - 1, false);
            else
                slide_input.value = this.content.getCurrentSlideIndex() + 1;
            // Take away focus
            slide_input.blur();
        }
    };
    // ---
    // Description: Called whenever the night mode button is clicked.
    // ---
    Rslidy.prototype.toggleLowLightMode = function () {
        // Inverts everything, then reverts individual elements again after "html"
        // which should stay the same (e.g. images)
        var invert = ["html", "img"];
        for (var i = 0; i < invert.length; i++) {
            var elements = document.getElementsByTagName(invert[i]);
            this.utils.switchElementsClass(elements, "rslidy-color-invert");
        }
        // Add custom classes to h1, h2, h3, p, span, li, ul, ol, pre and a
        var custom_classes = [
            "h1",
            "h2",
            "h3",
            "p",
            //"span",
            "li",
            "ul",
            "ol",
            "pre",
            "a"
        ];
        for (var i = 0; i < custom_classes.length; i++) {
            var elements = document.getElementsByTagName(custom_classes[i]);
            this.utils.switchElementsClass(elements, "rslidy-night-mode");
            this.utils.invertElementsColor(elements, this.low_light_mode);
        }
        this.low_light_mode = !this.low_light_mode;
    };
    // ---
    // Description: Called whenever the address field content changes.
    // ---
    Rslidy.prototype.onHashchange = function () {
        if (window.location.hash.match(/#[0-9]+/))
            this.content.showSlide(this.content.getCurrentSlideIndex(), false);
    };
    // ---
    // Description: Called whenever the orientation of a device changes.
    // e: Event.
    //
    // Tilt controls are implemented as follows: There are 3 angles, tilt_center
    // tilt_lower and tilt_upper. If the device is tilted above the lower angle
    // and back to the center, a tilt action is performed. If the devices is
    // tilted too far (above the upper angle), no action can be performed until
    // the device is tilted back to the center. With this switching from
    //  portrait to landscape mode causes no tilt action.
    // ---
    Rslidy.prototype.onDeviceOrientation = function (e) {
        var _this = this;
        //chrome fires this event with all values being null on all devices
        if (e.alpha == null && e.beta == null && e.gamma == null)
            return;
        // Init if event was fired and necessary
        var checkbox_tilt = document.getElementById("rslidy-checkbox-tilt");
        if (checkbox_tilt.disabled == true) {
            checkbox_tilt.disabled = false;
            checkbox_tilt.checked = true;
            document
                .getElementById("rslidy-checkbox-tilt-text")
                .setAttribute("aria-disabled", "false");
            document
                .getElementById("rslidy-checkbox-tilt-text")
                .setAttribute("aria-checked", "true");
            document
                .getElementById("rslidy-checkbox-tilt-text")
                .classList.remove("rslidy-disabled");
        }
        // Return if not activated
        if (checkbox_tilt.checked == false)
            return;
        // Store values
        var value = 0;
        var tilt_multiplier = 1;
        var safari = /.*Version.*Safari.*/.test(navigator.userAgent);
        if (window.innerHeight > window.innerWidth) {
            // Portrait mode
            value = Math.round(e.gamma);
            tilt_multiplier = 1.75;
            // safari has -180 and 180, others -90 and 90
            if (safari) {
                value /= 1.5;
                tilt_multiplier = 1;
            }
        }
        else {
            // Landscape mode
            value = Math.round(e.beta);
            // safari has -90 and 90, others -180 and 180
            if (safari)
                value *= 2;
        }
        // Upside down Portrait/Landscape mode
        if ("orientation" in screen) {
            // @ts-ignore
            var orientation = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type;
            if (!(orientation === undefined) && orientation.includes("secondary"))
                value = -value;
        } // safari
        else if (window.orientation < 0 || window.orientation >= 180)
            value = -value;
        this.tilt = value;
        // Only allow tilt gestures after holding the device upright again
        if (value > -this.tilt_center && value < this.tilt_center) {
            if (this.tilt_allowed && this.tilt_action != null) {
                this.shift_pressed = true;
                this.tilt_action();
                this.tilt_action = null;
                this.shift_pressed = false;
            }
            this.tilt_allowed = true;
        }
        if (value >= this.tilt_lower * tilt_multiplier &&
            value <= this.tilt_upper * tilt_multiplier)
            this.tilt_action = function () { return _this.content.navNext(true); };
        if (value <= -this.tilt_lower * tilt_multiplier &&
            value >= -this.tilt_upper * tilt_multiplier)
            this.tilt_action = function () { return _this.content.navPrevious(true); };
        if (value >= this.tilt_upper * tilt_multiplier ||
            value <= -this.tilt_upper * tilt_multiplier) {
            this.tilt_action = null;
            this.tilt_allowed = false;
        }
    };
    // ---
    // Description: Called whenever the acceleration of the device changes.
    // e: Event.
    //
    // The shake gesture fires when the number of consecutive shakes (stored in
    // the variable shakes) exceeds the value of the variable required_shakes
    // within a certain time limit (defined by the variable shake_time_limit)
    // ---
    Rslidy.prototype.onDeviceMotion = function (e) {
        //chrome fires this event with all values being null on all devices
        if (e.acceleration.x == null &&
            e.acceleration.y == null &&
            e.acceleration.z == null)
            return;
        // Init if event was fired and necessary
        var checkbox_shake = document.getElementById("rslidy-checkbox-shake");
        if (checkbox_shake.disabled == true) {
            checkbox_shake.disabled = false;
            checkbox_shake.checked = true;
            document
                .getElementById("rslidy-checkbox-shake-text")
                .setAttribute("aria-disabled", "false");
            document
                .getElementById("rslidy-checkbox-shake-text")
                .setAttribute("aria-checked", "true");
            document
                .getElementById("rslidy-checkbox-shake-text")
                .classList.remove("rslidy-disabled");
        }
        // Return if not activated
        if (checkbox_shake.checked == false)
            return;
        var acc_threshold = 10.0 / this.shake_sensitivity;
        var now = (new Date).getTime();
        var shake_interval = Math.abs(now - this.last_shake);
        // Reset shake counter when past the time limit
        if (shake_interval > this.shake_time_limit) {
            this.shakes = 0;
            this.last_shake = now;
        }
        // Increase shake counter if shake is stronger than threshold
        if ((e.acceleration.x > acc_threshold ||
            e.acceleration.y > acc_threshold ||
            e.acceleration.z > acc_threshold) &&
            shake_interval < this.shake_time_limit &&
            shake_interval > this.min_shake_interval) {
            this.shakes += 1;
            if (this.shakes >= this.required_shakes)
                this.content.navFirst();
            this.last_shake = now;
        }
    };
    // ---
    // Description: Toggles speaker nodes for current slide if available.
    // e: Event coming from double tap, null otherwise.
    // always_hide: If true, speaker nodes are hidden regardless of the current
    // status.
    // ---
    Rslidy.prototype.toggleSpeakerNotes = function (e, always_hide) {
        always_hide = always_hide || false;
        // Get current status
        var speaker_notes_overlay = document.getElementById("rslidy-speakernotes-overlay");
        var hidden = speaker_notes_overlay.classList.contains("rslidy-hidden");
        // Hide speaker notes if necessary
        if (hidden == false || always_hide == true) {
            speaker_notes_overlay.classList.add("rslidy-hidden");
            // Prevent default double tap event if notes were visible
            if (e != null && hidden == false) {
                e.preventDefault();
                e.stopPropagation();
            }
            return;
        }
        // Get current speaker notes (if there are any)
        var content_section = document.getElementById("rslidy-content-section");
        var current_slide = content_section.getElementsByClassName("slide")[this.content.getCurrentSlideIndex()];
        var speaker_notes = current_slide.getElementsByClassName("speakernotes").length == 1
            ? current_slide.getElementsByClassName("speakernotes")[0]
            : null;
        // Show speaker notes and set new text if necessary
        if (speaker_notes != null) {
            speaker_notes_overlay.classList.remove("rslidy-hidden");
            speaker_notes_overlay.innerHTML =
                '<div class="rslidy-speakernotes-container">' +
                    speaker_notes.innerHTML +
                    "</div>";
            // Prevent default double tap event if notes were hidden
            if (e != null && hidden == true) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    };
    return Rslidy;
}());
exports.Rslidy = Rslidy;
function start() {
    var t0 = performance.now();
    //inject loading spinner and hide body overflowing behind the spinner
    document.body.insertAdjacentHTML('afterbegin', html_definitions_1.spinner_html);
    document.body.style.overflow = 'hidden';
    //timeout allows the browser to repaint and display the spinner
    setTimeout(function () {
        window.rslidy.init();
        //hide the spinner again after rslidy is done
        document.getElementById('rslidy-spinner').classList.add('rslidy-hidden');
        var t1 = performance.now();
        console.log("Time to first slide: " + (t1 - t0) + " milliseconds.");
    }, 1);
}
window.rslidy = new Rslidy();
document.addEventListener("DOMContentLoaded", start);
